import * as actionTypes from '../Register_action.types';

const initialState = {
  loggingIn: false,
  reports: [],
  error: null,
  message: '',
};

const getAllReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_EMPLOYEE_REPORTS_REQUEST:
    case actionTypes.GET_ALL_EMPLOYEE_REPORTS_AS_PER_DATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.GET_ALL_EMPLOYEE_REPORTS_SUCCESS:
    case actionTypes.GET_ALL_EMPLOYEE_REPORTS_AS_PER_DATE_SUCCESS:
      return {
        ...state,
        loading: false,
        reports: action.payload,

      }
    case actionTypes.GET_ALL_EMPLOYEE_REPORTS_FAILURE:
    case actionTypes.GET_ALL_EMPLOYEE_REPORTS_AS_PER_DATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default getAllReportsReducer
